import { getUserInfo } from '@/api/user';
import sObserver from '@/utils/simpleObserver';
import { delToken } from '@/utils/token';
const getDefaultState = () => {
  return {
    name: '',
    avatar: '',
    userInfo: null,
    token: null,
    isNewUser: false,
    org: null,
    headerLoginJump: false,
  };
};

const state = getDefaultState();

const mutations = {
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_USERINFO: (state, { data, router }) => {
    state.userInfo = { ...state.userInfo, ...data.userInfo };
  },
  GET_USERINFO: (state, data) => {
    getUserInfo().then(res => {
      if (res?.code === 200) {
        state.userInfo = res.data;
        if (res.data.timeSinceRegistration < 2) {
          state.isNewUser = true;
        }
        sObserver.fire('laoshibang-userInfo');
      }
    });
  },
  LOGIN_OUT: (state, router) => {
    state.token = null;
    state.userInfo = null;
    state.org = null;
    // const abTestInfo = JSON.parse(localStorage.getItem('abTestInfo'));
    // if(abTestInfo?.strategy === 'A') {
    router.push({ path: '/home/index' });
    // } else if(abTestInfo?.strategy === 'B') {
    //   router.push({ path: '/apps/index' });
    // }
    delToken();
  },
  SET_ORG: (state, org) => {
    state.org = org;
  },
  SET_HEADER_LOGIN_JUMP: (state, headerLoginJump) => {
    state.headerLoginJump = headerLoginJump;
  },
};

const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
